'use strict';

const $ = jQuery.noConflict();
$(function() {

	/**
	 * Category chips and pagination load the listing in place (no page reload),
	 * URL is updated so a filter can be shared, and browser back/forward buttons work.
	 */
	const blogListing = {

		init: function() {
			this.cacheDOM();
			if (!this.$listing.length) {
				return;
			}
			this.bindEvents();
			this.revealActiveChip();
		},

		cacheDOM: function() {
			this.$listing = $('.js-blog-listing');
			this.$results = $('.js-blog-results');
			this.$filters = $('.js-blog-filters');
			this.$search = $('.js-blog-search');
			this.$searchInput = $('.js-blog-search-input');
			this.$searchClear = $('.js-blog-search-clear');
			this.request = null;
		},

		bindEvents: function() {
			this.$listing.on('click', '.js-blog-link', this.handleLinkClick.bind(this));
			this.$searchInput.on('input', this.syncSearchState.bind(this));
			this.$searchClear.on('click', this.handleClear.bind(this));
			$(window).on('popstate', () => this.load(window.location.href, false));
		},

		// search field: toggle "clear" button and the "filled" look
		syncSearchState: function() {
			const hasValue = this.$searchInput.val().length > 0;
			this.$searchClear.prop('hidden', !hasValue);
			this.$search.toggleClass('is-filled', hasValue);
		},

		// clear input; on the search results page leave the results and go back to the blog
		handleClear: function() {
			const resetUrl = this.$search.data('reset-url');
			if (resetUrl) {
				window.location.href = resetUrl;
				return;
			}
			this.$searchInput.val('').trigger('focus');
			this.syncSearchState();
		},

		// chips, pagination and links in empty states
		handleLinkClick: function(e) {
			// leave modified clicks (new tab, etc.) to the browser
			if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.which > 1) {
				return;
			}

			// on the search results page chips lead back to the blog, regular navigation
			if (this.$search.data('reset-url')) {
				return;
			}

			e.preventDefault();
			const url = e.currentTarget.href;
			if (url === window.location.href) {
				return;
			}
			this.load(url, true);
		},

		// fetch the page and swap chips state and results
		load: function(url, push) {
			if (this.request) {
				this.request.abort();
			}
			this.$results.addClass('is-loading').attr('aria-busy', 'true');

			this.request = $.ajax({
				method: 'GET',
				url: url,
				dataType: 'html',
			}).done((html) => {
				const $doc = $('<div>').append($.parseHTML(html));
				const $newResults = $doc.find('.js-blog-results').first();
				if (!$newResults.length) {
					window.location.href = url;
					return;
				}

				this.$results.html($newResults.html());
				this.updateChips($doc);
				if (push) {
					window.history.pushState({}, '', url);
				}
				this.scrollToListing(push);
			}).fail((jqXHR, textStatus) => {
				if (textStatus !== 'abort') {
					window.location.href = url;
				}
			}).always((jqXHR, textStatus) => {
				if (textStatus !== 'abort') {
					this.$results.removeClass('is-loading').removeAttr('aria-busy');
				}
			});
		},

		// mark the chip of the loaded category as active
		updateChips: function($doc) {
			const active = $doc.find('.js-blog-filters .blog-chip.is-active').first().data('category') || '';
			this.$filters.find('.blog-chip').each(function() {
				const $chip = $(this);
				const isActive = ($chip.data('category') || '') === active;
				$chip.toggleClass('is-active', isActive);
				if (isActive) {
					$chip.attr('aria-current', 'true');
				} else {
					$chip.removeAttr('aria-current');
				}
			});
			this.revealActiveChip();
		},

		// on a phone chips scroll horizontally, keep the active one visible
		revealActiveChip: function() {
			const $list = this.$filters.find('.blog-filters__list');
			const $active = $list.find('.blog-chip.is-active');
			if (!$list.length || !$active.length || $list[0].scrollWidth <= $list[0].clientWidth) {
				return;
			}
			const offset = $active[0].offsetLeft - ($list[0].clientWidth - $active[0].offsetWidth) / 2;
			$list[0].scrollLeft = Math.max(0, offset);
		},

		// bring the top of the results into view when the page is changed
		scrollToListing: function(push) {
			const $anchor = this.$filters.length ? this.$filters : this.$results;
			const top = $anchor.offset().top - 120;
			if (push && window.scrollY > top) {
				window.scrollTo({top: top, behavior: 'smooth'});
			}
		},
	};

	blogListing.init();
});
